const locale = {
  CHANGE_PASSWORD: 'Change your password',
};

export default locale;
